/* ==========================================================================
   KPod bundle builder — mix and match N boxes for a percentage off
   --------------------------------------------------------------------------
   Numbers come from the JSON blob snippets/kpod-bb-flavours.liquid renders.
   Nothing here scrapes a price out of the DOM, and nothing here hardcodes the
   discount — it arrives as data-bb-discount from the section setting.

   The discount is a Shopify AUTOMATIC discount applied in the cart. This file
   only predicts it, and only once the bundle actually qualifies: below the
   target the customer sees the plain subtotal, because at 5 boxes there is no
   discount to promise.
   ========================================================================== */
(function () {
  'use strict';

  function money(pence, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency || 'GBP'
      }).format(pence / 100);
    } catch (e) {
      return '£' + (pence / 100).toFixed(2);
    }
  }

  /* The store's popout cart is SlideCart HQ, not the theme's own drawer — the
     Ecomus `cart-drawer` section is disabled in sections/system-group.json, so
     no <hdt-cart-drawer> exists on the page and the header cart link is a plain
     <a href="/cart"> that SlideCart intercepts.

     SlideCart does not observe fetch() calls, so an XHR add leaves it showing a
     stale cart until the page reloads. It has to be told. Verified against the
     live storefront: after adding 3 boxes the server cart read 3 while
     SLIDECART_STATE().cart.item_count still read 0; SLIDECART_UPDATE() brought
     it to 3.

     The theme-drawer branch is the fallback if that section is ever re-enabled.
     It needs `cart.sections` — pre-rendered HTML keyed by section id — because
     the drawer renders from detail.cart.sections[itsSectionId]. */
  function refreshCartUI(cart) {
    // Two separate consumers, and BOTH must be told — an early return after the
    // popout leaves the header badge reading 0 until the next page load.
    //
    // 1. The theme's header count and dot are <hdt-cart-count> / <hdt-cart-dot>.
    //    They listen on document for `cart:change` and read
    //    detail.cart.item_count. Their only other refresh is `cart:refresh` or
    //    the window `pageshow` event, which is why a stale badge looks like it
    //    needs a refresh — it literally does.
    document.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart: cart }
      })
    );

    // 2. The popout itself. SlideCart does not observe fetch(), so it has to be
    //    updated explicitly and then opened.
    if (typeof window.SLIDECART_UPDATE === 'function') {
      var open = function () {
        if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
      };
      try {
        var res = window.SLIDECART_UPDATE();
        if (res && typeof res.then === 'function') res.then(open, open);
        else open();
        return;
      } catch (e) {
        if (window.console) console.warn('[kpod-bb] SlideCart refresh failed', e);
      }
    }

    // Fallback for the theme's own drawer, if that section is ever re-enabled.
    // Guarded on the element existing: unguarded, this navigates to /cart on
    // stores where the header cart is an ordinary link.
    if (document.querySelector('hdt-cart-drawer')) {
      var trigger = document.querySelector('[aria-controls="CartDrawer"]');
      if (trigger) trigger.click();
    }
  }

  function capture(event, props) {
    if (typeof posthog === 'undefined' || !posthog.capture) return;
    try {
      posthog.capture(event, props || {});
    } catch (e) {
      /* analytics must never break the builder */
    }
  }

  function init(root) {
    var instance = root.getAttribute('data-bb-instance');
    var dataEl = document.getElementById('kpod-bb-data-' + instance);
    if (!dataEl) return;

    var flavours;
    try {
      flavours = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    // A collection can contain no pod boxes at all — snippets/kpod-bb-flavours
    // skips anything without an NxM pack variant. Showing a progress bar and a
    // dead CTA over an empty grid would just look broken.
    if (!flavours || !flavours.length) {
      var emptyBar = root.querySelector('[data-bb-bar]');
      if (emptyBar) emptyBar.hidden = true;
      return;
    }

    var TARGET = parseInt(root.getAttribute('data-bb-target'), 10) || 8;
    var PCT = parseFloat(root.getAttribute('data-bb-discount')) || 0;
    var CURRENCY = root.getAttribute('data-bb-currency') || 'GBP';

    var byId = {};
    flavours.forEach(function (f) {
      byId[String(f.id)] = f;
    });

    var grid = root.querySelector('[data-bb-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bb-card]'));
    var countEl = root.querySelector('[data-bb-count]');
    var fillEl = root.querySelector('[data-bb-fill]');
    var pricesEl = root.querySelector('[data-bb-prices]');
    var wasEl = root.querySelector('[data-bb-was]');
    var nowEl = root.querySelector('[data-bb-now]');
    var saveEl = root.querySelector('[data-bb-save]');
    var submit = root.querySelector('[data-bb-submit]');
    var hintEl = root.querySelector('[data-bb-hint]');
    var errorEl = root.querySelector('[data-bb-error]');

    if (!grid || !submit) return;

    var qty = {};

    function totalBoxes() {
      var n = 0;
      for (var id in qty) {
        if (Object.prototype.hasOwnProperty.call(qty, id)) n += qty[id];
      }
      return n;
    }

    function subtotal() {
      var sum = 0;
      for (var id in qty) {
        if (Object.prototype.hasOwnProperty.call(qty, id)) {
          var f = byId[id];
          if (f) sum += f.price * qty[id];
        }
      }
      return sum;
    }

    function paint() {
      var total = totalBoxes();
      var full = total >= TARGET;
      var sub = subtotal();

      cards.forEach(function (card) {
        var id = card.getAttribute('data-bb-id');
        var n = qty[id] || 0;
        var out = card.hasAttribute('data-bb-out');

        var qtyEl = card.querySelector('[data-bb-qty]');
        var dec = card.querySelector('[data-bb-dec]');
        var inc = card.querySelector('[data-bb-inc]');

        if (qtyEl) qtyEl.textContent = String(n);
        if (dec) dec.disabled = n === 0;
        if (inc) inc.disabled = out || full;
        card.classList.toggle('kpod-bb__card--picked', n > 0);
      });

      if (countEl) {
        countEl.textContent = total + ' of ' + TARGET + ' boxes chosen';
      }
      if (fillEl) {
        fillEl.style.width = Math.min(100, (total / TARGET) * 100) + '%';
      }

      // Price block. Below the target there is no discount to show, so the
      // customer sees the plain running subtotal and no saving claim.
      if (pricesEl) {
        pricesEl.hidden = total === 0;
        if (total > 0) {
          var qualifies = total === TARGET && PCT > 0;
          var youPay = qualifies ? Math.round(sub * (1 - PCT / 100)) : sub;

          if (nowEl) nowEl.textContent = money(youPay, CURRENCY);
          if (wasEl) {
            wasEl.hidden = !qualifies;
            wasEl.textContent = qualifies ? money(sub, CURRENCY) : '';
          }
          if (saveEl) {
            saveEl.hidden = !qualifies;
            saveEl.textContent = qualifies ? 'You save ' + money(sub - youPay, CURRENCY) : '';
          }
        }
      }

      submit.disabled = total !== TARGET;

      if (hintEl) {
        if (total === TARGET) {
          hintEl.textContent = '';
        } else if (total === 0) {
          hintEl.textContent = 'Choose ' + TARGET + ' boxes to continue';
        } else {
          var left = TARGET - total;
          hintEl.textContent = 'Choose ' + left + ' more box' + (left === 1 ? '' : 'es');
        }
      }
    }

    function bump(id, delta) {
      var f = byId[id];
      if (!f || !f.available) return;

      var n = qty[id] || 0;
      var next = n + delta;
      if (next < 0) return;
      if (delta > 0 && totalBoxes() >= TARGET) return;

      if (next === 0) delete qty[id];
      else qty[id] = next;

      paint();

      capture('bb_qty_change', {
        blend: f.title,
        variant_id: f.id,
        action: delta > 0 ? 'add' : 'remove',
        qty: next,
        total_boxes: totalBoxes()
      });
    }

    grid.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-bb-inc], [data-bb-dec]') : null;
      if (!btn || !grid.contains(btn) || btn.disabled) return;

      var card = btn.closest('[data-bb-card]');
      if (!card) return;

      bump(card.getAttribute('data-bb-id'), btn.hasAttribute('data-bb-inc') ? 1 : -1);
    });

    submit.addEventListener('click', function () {
      if (submit.disabled) return;

      var total = totalBoxes();
      if (total !== TARGET) return;

      // Repeats are aggregated into quantity: 3 x Boston Breakfast is one line
      // at quantity 3, not three lines.
      var items = [];
      var blends = [];
      for (var id in qty) {
        if (!Object.prototype.hasOwnProperty.call(qty, id)) continue;
        items.push({ id: parseInt(id, 10), quantity: qty[id] });
        blends.push({ title: byId[id] ? byId[id].title : id, qty: qty[id] });
      }
      if (!items.length) return;

      var sub = subtotal();
      var youPay = PCT > 0 ? Math.round(sub * (1 - PCT / 100)) : sub;

      submit.disabled = true;
      if (errorEl) errorEl.hidden = true;

      // Any section that re-renders on cart change registers its id here. Empty
      // on this store (the theme drawer is off), but it costs nothing and keeps
      // the fallback path in refreshCartUI correct if it is turned back on.
      var wantSections = [];
      try {
        document.dispatchEvent(
          new CustomEvent('cart:push:section.id', {
            bubbles: true,
            detail: { sections: wantSections }
          })
        );
      } catch (e) {
        /* no listeners is fine */
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: wantSections.join(','),
          sections_url: window.location.pathname
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart/add failed: ' + r.status);
          return r.json();
        })
        .then(function (added) {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) {
              return r.json();
            })
            .then(function (cart) {
              // Graft the rendered section HTML onto the cart object, which is
              // the shape the theme's own drawer expects.
              cart.sections = added && added.sections;
              return cart;
            });
        })
        .then(function (cart) {
          capture('bb_add_to_cart', {
            boxes: total,
            line_value: sub / 100,
            discounted_value: youPay / 100,
            cart_value: cart.total_price / 100,
            blends: blends
          });

          refreshCartUI(cart);
        })
        .catch(function (err) {
          if (window.console) console.warn('[kpod-bb] add failed', err);
          capture('bb_add_failed', { error: String(err && err.message ? err.message : err) });
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = 'Sorry — that did not add to your basket. Please try again.';
          }
        })
        .then(function () {
          submit.disabled = totalBoxes() !== TARGET;
        });
    });

    paint();

    // Fire the view event once the builder is actually on screen.
    if ('IntersectionObserver' in window) {
      var seen = false;
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || seen) return;
            seen = true;
            io.disconnect();
            capture('bb_view', { flavour_count: flavours.length });
          });
        },
        { threshold: 0.25 }
      );
      io.observe(root);
    } else {
      capture('bb_view', { flavour_count: flavours.length });
    }
  }

  function boot() {
    document.querySelectorAll('[data-kpod-bb]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-kpod-bb]') : null;
    if (root) init(root);
  });
})();
